import React, { Fragment } from "react"
import { Link } from "gatsby"

const UkOptions = () => {
    return (<Fragment>
        <div className="kuda-footer--col">
            <p className="footer-header text-bold color-primary">Features</p>
            <ul className="kuda-footer--menu color-black">

                <li>
                    <Link to="/en-gb/payments/">Payment & Transfers</Link>
                </li>
                <li>
                    <Link to="/">Instant Account</Link>
                </li>

            </ul>
        </div>

        <div className="kuda-footer--col">
            <p className="footer-header text-bold color-primary">Company</p>
            <ul className="kuda-footer--menu color-black">

                <li>
                    {/* <a
                        href="https://joinkuda.medium.com/"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                    >
                        Blog
                    </a> */}
                    <Link
                        to="/blog/"
                        className="menu-link"
                    > Blog

                    </Link>
                </li>
                <li>
                    <Link to="/press/">Press</Link>
                </li>
                <li>
                    <Link to="/careers/">Join Our Team</Link>
                </li>
                <li>
                    <Link to="/en-gb/about/">About Us</Link>
                </li>
                <li>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://developer.tell.money/kudaOpenBanking">
                        Developers
                    </a>
                </li>

            </ul>
        </div>
        <div className="kuda-footer--col">
            <p className="footer-header text-bold color-primary">Help</p>
            <ul className="kuda-footer--menu color-black">

                <li>
                    <Link to="/en-gb/legal/faq/"> Get Help</Link>


                </li>

                <li>
                    <Link to="/scam-awareness/">Scam Awareness</Link>
                </li>
                <li>
                    <Link to="/security/">Security</Link>
                </li>
                <li>
                    <Link to="/en-gb/contact/">Contact Us</Link>
                </li>

                <li>
                    <a
                        href="https://selfhelp.kuda.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Self Help
                    </a>

                </li>
            </ul>
        </div>
        <div className="kuda-footer--col">
            <p className="footer-header text-bold color-primary">Transparency</p>
            <ul className="kuda-footer--menu color-black">


                <li>
                    <Link to="/en-gb/legal/terms/">Terms & Conditions</Link>
                </li>
                <li>
                    <Link to="/en-gb/legal/privacy-policy/">Privacy Policy</Link>
                </li>
                <li>
                    <Link to="/en-gb/legal/complaints-policy/">Information security policy</Link>
                </li>
                <li>
                    <Link to="/en-gb/legal/cookie-policy/">Cookie Policy</Link>
                </li>

            </ul>
        </div>
    </Fragment>
    )
}
export default UkOptions